var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items)?_c('ul',{staticClass:"menu-items"},_vm._l((_vm.items),function(link){return _c('li',{key:link.url},[_c('a',{staticClass:"wb-type-copy",attrs:{"target":link.target,"href":link.url}},[_vm._v(_vm._s(link.label))])])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }